import Activity from '@rio-cloud/rio-uikit/Activity';
import type { JSX } from 'react';

import { ActivityConfig } from '../../enums/Activities';
import { formatDuration } from '../../formatting/TimeFormatting';
import { TooltipWrapper } from '../../onboarding/TooltipWrapper';
import { EmptyDataIconWithTooltip } from '../elements/EmptyDataIcon';
import type { StatusDuration } from './types';

interface StatusDurationCellProps {
    value?: StatusDuration;
}

export const StatusDurationCell = (props: StatusDurationCellProps): JSX.Element => {
    const { value } = props;

    if (!value) {
        return <EmptyDataIconWithTooltip />;
    }

    const { translationId, uikitActivity } = ActivityConfig[value.status];
    return (
        <div className={'cards-justify-content'}>
            <TooltipWrapper tooltipId={translationId}>
                <div className={'display-inline-block'}>
                    <Activity activity={uikitActivity} duration={formatDuration(value.duration)} />
                </div>
            </TooltipWrapper>
        </div>
    );
};
